import { IOptions } from '@acorn-portal/shared/src/components/inputs/select';
import getClosestMileage from '@acorn-portal/shared/src/utils/getClosestMileage';
import { IFormChangeAddress } from './get-address-initial-values';

// used to verify if data has changed, then further processing on quote transformation
export const getFormattedFormValues = (
	values: IFormChangeAddress,
	annualMileageOptions: IOptions[],
): IFormChangeAddress => {
	return {
		isHomeOwner: values.isHomeOwner,
		address: {
			line1: values.address.line1,
			line2: values.address.line2,
			line3: values.address.line3,
			line4: values.address.line4,
			city: values.address.city,
			county: values.address.county,
			country: values.address.country,
			postcode: values.address.postcode,
		},
		overnightAddress: {
			line1: values.overnightAddress.line1,
			line2: values.overnightAddress.line2,
			line3: values.overnightAddress.line3,
			line4: values.overnightAddress.line4,
			city: values.overnightAddress.city,
			county: values.overnightAddress.county,
			country: values.overnightAddress.country,
			postcode: values.overnightAddress.postcode,
		},
		annualMileage: getClosestMileage(annualMileageOptions, parseInt(values.annualMileage)),
		businessMileage: values.businessMileage || '',
		keptOvernight: values.keptOvernight,
		overnightAddressIsAway: values.overnightAddressIsAway,
	};
};
